export const MATTER_LIEN_CATEGORY_OPTIONS = [
  "Medical",
  "Statutory",
  "Attorney",
] as const;

export const MATTER_LIEN_SUBCATEGORY_OPTIONS_BY_CATEGORY = {
  Medical: [
    "Health Insurance / Subrogation",
    "Medicare",
    "Medicaid",
    "Hospital",
    "Provider/Doctor",
    "Letter of Protection (LOP)",
  ],
  Statutory: ["Child Support", "Workers' Compensation", "Government Benefits"],
  Attorney: ["Prior Attorney Lien", "Attorney Backpay Liens"],
} as const satisfies Record<
  (typeof MATTER_LIEN_CATEGORY_OPTIONS)[number],
  readonly string[]
>;

export const MATTER_LIEN_SUBCATEGORY_OPTIONS = [
  ...MATTER_LIEN_SUBCATEGORY_OPTIONS_BY_CATEGORY.Medical,
  ...MATTER_LIEN_SUBCATEGORY_OPTIONS_BY_CATEGORY.Statutory,
  ...MATTER_LIEN_SUBCATEGORY_OPTIONS_BY_CATEGORY.Attorney,
] as const;
